import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InicioFaces} from '../interfaces/inicioFaces';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";



@Injectable({
providedIn: 'root'
})
export class ConsultaService {
public httpOptions = {
headers: new HttpHeaders({
'Access-Control-Allow-Origin': '*'
})

};
API_ENDPOINT: string = Constants.BASEURLAPI  + '/api';
// API_ENDPOINT: string = Constants.BASEURLAPI;


constructor(private httpClient: HttpClient) { }
static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
	let config = {
		'required': 'Este campo es requerido'
	};
	return config[validatorName];
}

public consultReporte(caso_id : any) {
const  params = new  HttpParams().set('caso_id', caso_id);
return this.httpClient.get(this.API_ENDPOINT + '/consultReporte',{params});
} 


public mostrarReporte() {
    return this.httpClient.get(this.API_ENDPOINT + '/mostrarReporte', this.httpOptions);
    }

public responder(respuesta : any){
		console.log("beeeeee", respuesta);
        return this.httpClient.post<any>(this.API_ENDPOINT+'/responder/',respuesta);
       }  
}
